{
  "appointment-card": {
    "buttons": {
      "details": "Details"
    },
    "text": {
      "and-more": "and {{nr}} more",
      "cancelled": "CANCELLED",
      "minutes": "minutes"
    }
  }
}
